export const FETCH_PHOTO_SESSION_DETAIL = 'FETCH_PHOTO_SESSION_DETAIL';
export const PHOTO_SESSION_DETAIL_PAGE_VIEWED_ANALYTICS =
  'PHOTO_SESSION_DETAIL_PAGE_VIEWED_ANALYTICS';
export const PHOTO_SESSION_DETAIL_CONFIRMATION_CLICKED_ANALYTICS =
  'PHOTO_SESSION_DETAIL_CONFIRMATION_CLICKED_ANALYTICS';
export const PHOTO_SESSION_DETAIL_CALL_OWNER_CLICKED_ANALYTICS =
  'PHOTO_SESSION_DETAIL_CALL_OWNER_CLICKED_ANALYTICS';
export const PHOTO_SESSION_DETAIL_DIRECTIONS_CLICKED_ANALYTICS =
  'PHOTO_SESSION_DETAIL_DIRECTIONS_CLICKED_ANALYTICS';
export const PHOTO_SESSION_START_CLICKED_ANALYTICS =
  'PHOTO_SESSION_START_CLICKED_ANALYTICS';
export const FETCH_ENTRY_ACCESS = 'FETCH_ENTRY_ACCESS';
export const PHOTO_SESSION_DETAIL_ENTRY_MODEL_ALERT_LINK_CLICKED_ANALYTICS =
  'PHOTO_SESSION_DETAIL_ENTRY_MODEL_ALERT_LINK_CLICKED_ANALYTICS';
export const FETCH_LISTING_REPRESENTATIVE = 'FETCH_LISTING_REPRESENTATIVE';
